export const createAuthorizationHeader = (idToken: string) => ({ Authorization: `Bearer ${idToken}` })
